<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Аллергии пациента</h1>
      </v-col>

      <v-col align="right">
        <modal depressed icon="add" title="Добавить аллергию" name="Аллергию" component="add-allergy"></modal>
      </v-col>
    </v-row>

    <patient-header />
    <allergy-list />
  </v-container>
</template>

<script>
import AllergyList from "./components/AllergyList";
import Modal from "@/components/Modal";

import PatientHeader from "@/components/PatientHeader";
export default {
  name: "AllergyListPage",

  components: {
    AllergyList,
    Modal,
    PatientHeader,
  },
};
</script>

<style scoped></style>
